import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {TrafficPacksService} from '../../services/traffic-packs.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app-state';
import {BehaviorSubject, interval, Subscription} from 'rxjs';
import {User} from '../../../interfaces/user';
import {switchMap, take} from 'rxjs/operators';
import {AvailableTrafficPack} from '../../interfaces/available-traffic-pack';
import {CommonService} from '../../../services/common.service';
import {Title} from '@angular/platform-browser';
import {ActivePack} from '../../interfaces/active-pack';
import {DashboardSubscriptionsModel} from '../../models/dashboardSubscriptionsModel';
import {Router} from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit, OnDestroy {

  availableTrafficPacks?: AvailableTrafficPack[];
  activePack?: ActivePack;
  newsData?: any;
  user: User | null;
  clientIp?: string | null;
  pageLoading = true;
  timeIsOver = false;
  subscriberAuthip?: string | null;
  dashboardSubscriptionsModel: DashboardSubscriptionsModel;
  listInitializer: BehaviorSubject<DashboardSubscriptionsModel>;
  voluntaryBlocking = false;
  router = inject(Router);

  private subscriptions = new Subscription();

  constructor(private trafficPacksService: TrafficPacksService,
              private commonService: CommonService,
              private store: Store<{ app: AppState }>,
              private titleService: Title,) {
    this.dashboardSubscriptionsModel = new DashboardSubscriptionsModel();
    this.listInitializer = new BehaviorSubject(this.dashboardSubscriptionsModel);
  }

  ngOnInit(): void {
    this.titleService.setTitle('Личный кабинет Hotspot');

    this.initCommonDataObserver();
    this.initAvailableTrafficPacksObserver();
    this.initActivePackObserver();
    this.initCheckReadyObserver();

    this.initReadyFallBack();
  }

  private initReadyFallBack(): void {
    setTimeout(() => { // TODO МЕВ: подумать как избавиться от таймаута.
      this.pageLoading = false;
      this.commonService.setFullPageLoaderVisibility(false);
      this.timeIsOver = true;
    }, 3000);

  }

  private initCheckReadyObserver(): void {
    // Проверяем отработали ли стартовые запросы. Если да, то отключаем индикатор загрузки.
    this.subscriptions.add(interval(100).pipe(
      take(30),
    ).subscribe({
      next: (value: number) => {
        if (this.availableTrafficPacks && this.activePack) {
          this.pageLoading = false;
          this.commonService.setFullPageLoaderVisibility(false);
        }
      },
      error: (error: any) => {},
      complete: () => {
        this.timeIsOver = false;
      }
    }));
  }

  private initCommonDataObserver(): void {
    // Getting common data from store
    this.store.select('app', 'commonData')
      .pipe(take(1))
      .subscribe(commonData => {
        this.user = commonData?.user ?? null;
        if (this.user?.contract_blocked) {
          this.voluntaryBlocking = true;

        }
        this.clientIp = commonData?.client_ip ?? null;
        this.subscriberAuthip = commonData?.subscriber_auth_ip ?? null;
        this.newsData = commonData?.news_data?.news ?? [];
      });
  }

  private initAvailableTrafficPacksObserver(): void {
    this.subscriptions.add(
      this.listInitializer.pipe(
        switchMap((model: DashboardSubscriptionsModel) => this.trafficPacksService.getAvailableTrafficPacksToModel(model)),
      ).subscribe((response) => {
        if (response && response.availableTrafficPacks) {
          this.availableTrafficPacks = response.availableTrafficPacks;
        }
      })
    );
  }

  private initActivePackObserver(): void {
    this.subscriptions.add(
      this.listInitializer.pipe(
        switchMap((model: DashboardSubscriptionsModel) => this.trafficPacksService.getActivePackToModel(model))
      ).subscribe((response) => {
        if (response && response.activePack) {
          this.activePack = response.activePack;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
